export default "__VITE_ASSET__4Z16vBou__"